import Icon from '@mdi/react'
import type { IconProps } from '.'

const rocketSvg = `M13.13,22.19L11.5,18.36C13.07,17.78 14.54,17 15.9,16.09L13.13,22.19M5.64,12.5L1.81,10.87L7.91,8.1C7,9.46 6.22,10.93 5.64,12.5M21.61,2.39C21.61,2.39 16.66,0.269 11,5.93C8.81,8.12 7.5,10.53 6.65,12.64C6.37,13.39 6.56,14.21 7.11,14.77L9.24,16.89C9.79,17.45 10.61,17.63 11.36,17.35C13.5,16.53 15.88,15.19 18.07,13C23.73,7.34 21.61,2.39 21.61,2.39M8.88,16.53L7.47,15.12L8.88,16.53M6.24,22L9.88,18.36C9.54,18.27 9.21,18.12 8.91,17.91L4.83,22L6.24,22M2,22L3.41,22L8.18,17.24L6.76,15.83L2,20.59L2,22M2,19.17L6.09,15.09C5.88,14.79 5.73,14.47 5.64,14.12L2,17.76L2,19.17Z`

const Trending = (props: IconProps) => {
    const { filled, color, size = 0.9, title, ...other } = props
    return (
        <Icon
            data-testid="Icon__Trending"
            path={rocketSvg}
            title={title}
            size={size}
            color={color}
            {...other}
        />
    )
}

export default Trending
